import React, { useState } from "react";
import SidebarAdmin from '../../components/admin/Sidebar';
import "../../css/seller/ListTransaction.css";
import "../../css/seller/pesanan.css"
import { useNavigate } from 'react-router';
import DeleteConfirm from "../../components/DeleteConfirm";
import { useCookies } from 'react-cookie';
import Alert from "../../components/Alert";
import LoadingScreen from "../../components/LoadingScreen";
import NotFound from "../../components/NotFound";

export default function AdminDaftarToko() {
  const [isLoading, setIsLoading] = useState(false);
  const [Data, setData] = useState([])
  const navigate = useNavigate();
  const [confirmActive, setConfirmActive] = useState(false);
  const [imgId, setImgId] = useState();
  const [productId, setproductId] = useState();
  const [cookies, setCookie] = useCookies(['accessToken']);
  const [alertActive, setAlertActive] = useState(true);
  const [alert, setAlert] = useState({});
  const [filter, setFilter] = useState('')

  const activateAlert = () => {
    setAlertActive(true);
    setTimeout(() => {
      setAlertActive(false);
    }, 3000);
  };

  React.useEffect(() => {
    const fetchProduct = async (filter) => {
      try {
        setIsLoading(true);
        setData('')
        let url = 'https://w-shop-backend.vercel.app/api/sellers?';
        if (!!filter) {
          const params = new URLSearchParams();
          for (const [key, value] of Object.entries(filter)) {
            params.set(key, value);
          };
          url += params.toString();
        };
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
        })
        const body = await response.json();
        if (body.status !== "success") {
          throw new Error(body.message);
        }
        const product = body.data;
        product.sort((a, b) => a.id - b.id);
        setData(product);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      };
    }
    document.title = 'W-Shop Search';
    fetchProduct({ shopName: filter })
  }, [cookies.accessToken, filter])

  const handleDeleteProduct = async (idProduct, idImg) => {
    try {
      const url = `https://w-shop-backend.vercel.app/api/sellers/${idProduct}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + cookies.accessToken,
        },
      });
      const body = await response.json();
      if (body.status !== "success") {
        throw new Error(body.message);
      } else {
        const urlImg = `https://w-shop-backend.vercel.app/api/images?type=PROFILE_IMG&imageId=${idImg}`;
        await fetch(urlImg, {
          method: 'DELETE',
          headers: {
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
        })
        const event = {
          type: "alert",
          alert: {
            type: "success",
            message: "Produk ditambahkan ke keranjang",
          },
        };
        setCookie("event", event, { path: "/" });
        setAlert(event.alert);
        activateAlert();
        handleHideConfirm();
        window.location.reload();
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setAlert({
        type: "danger",
        message: "Error: " + error.message,
      });
      activateAlert();
    }
  };

  const handleShowConfirm = (idImg, idProduct) => {
    setConfirmActive(true);
    setproductId(idProduct);
    setImgId(idImg);
  };

  const handleHideConfirm = () => {
    setConfirmActive(false);
  };

  let adminToko = (<div>
    <DeleteConfirm
      active={confirmActive}
      message="Ingin menghapus produk ini ?"
      cancelHandler={handleHideConfirm}
      buttonMessage='Hapus'
      deleteHandler={() => {
        handleDeleteProduct(productId, imgId);
      }}
    />
    <LoadingScreen active={isLoading} />
    <div className="mainPesanan m-5 ms-auto me-auto p-5">
      <h1 className="pToko">Daftar Toko</h1>
      <hr />
      <div className=" d-flex ">
        <form className="d-md-flex justify-content-between d-blok" role="search">
          <div className="d-flex  ">
            <input className="form-control searchPesanan me-3" type="search" placeholder="Cari" aria-label="Search" onChange={(e) => { setFilter(e.target.value) }} />
            <button type="submit" className="btn btn-primary bSearchPesanan me-3"><img alt="" src="/img/icon-search.png" style={{ width: 30 }} /></button>
          </div>
        </form>
      </div>
      <hr />
      <h1 className="jumlahPesanan">{Data.length} Toko</h1>

      <hr />
      <div className='row pt-5' style={{ minHeight: "700px" }}>
        {
          Data.length > 0 ? (
            Data.map((data) => (
              <div key={data.id} className="col">
                <div className="card mb-5 " style={{ width: "256px", height: "379px", textDecoration: "none", background: '#E6E6FA' }}>
                  <img src={data.imgUrl} className="card-img-top" alt="..." style={{ height: "216px" }} />
                  <div className="card-body">
                    <h6 className='cardTitle'>{data.shopName}</h6>
                    <h6 className='cardPrice '>{data.owner}</h6>
                    <p className='cardTitle'>{data.address}</p>
                    <button className="bEdit btn btn-outline-primary" onClick={() => { navigate('/shopPage/' + data.id) }}>Lihat</button>
                    <button className="bHapus btn btn-outline-danger ms-3" onClick={() => { handleShowConfirm(data.imgId, data.id) }}>Hapus</button>
                  </div>
                </div>
              </div>
            ))) : (
            <NotFound />
          )
        }
      </div>
      <Alert active={alertActive} type={alert.type} message={alert.message} />
    </div >
  </div>)

  return (
    <div>
      <SidebarAdmin components={adminToko} titleAppBar={"Toko"} />
    </div>
  );
}
